<template>
  <div>
    <iq-card class="ml-3 mr-3">
        <template v-slot:headerTitle>
        <h4 class="card-title">Order History</h4>
        </template>
        <template v-slot:default>
          <el-skeleton :rows="5" animated v-if="loading" />
          <div v-else>
            <div v-if="orders.length">
                <div v-for="order in orders" :key="order.id">
                    <OrderHistoryItem class="mb-3" :order="order" ></OrderHistoryItem>
                </div>
            </div>
            <div v-else>
              <el-empty description="Looks like you haven't placed an order." />
            </div>
          </div>
        </template>
    </iq-card>
  </div>
</template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import firebase from '../../../firebase'
import { onMounted, ref } from 'vue'
import getOrders from '../../composables/getOrders'
import OrderHistoryItem from '../../components/OrderHistoryItem.vue'
const body = document.getElementsByTagName('body')

export default {
  name: 'ShopDevices',
  components: { IqCard, OrderHistoryItem },
  setup () {
    const { orders, loadOrders } = getOrders()
    const loading = ref(false)

    onMounted(async () => {
      loading.value = true
      await loadOrders(firebase.firebaseAuth.currentUser.uid)
      loading.value = false
    })

    return {
      orders,
      loading
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

    <style>

    .el-pager {
        margin-top: 15px !important;
    }
    </style>
